
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ExpertDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('pending');

  const stats = [
    { label: '待评审', value: '5', icon: 'ri-time-line', color: 'bg-orange-500' },
    { label: '评审中', value: '3', icon: 'ri-file-search-line', color: 'bg-blue-500' },
    { label: '已完成', value: '28', icon: 'ri-checkbox-circle-line', color: 'bg-green-500' },
    { label: '专家评分', value: '9.5', icon: 'ri-star-line', color: 'bg-yellow-500' }
  ];

  const pendingReviews = [
    {
      id: 1,
      projectName: '市政道路改造工程项目',
      projectCode: 'ZB2024001',
      bidders: 12,
      budget: '¥5,000万',
      reviewDeadline: '2024-02-16 17:00',
      inviteTime: '2024-02-10 10:00',
      status: '待开始'
    },
    {
      id: 2,
      projectName: '智慧园区信息化建设',
      projectCode: 'ZB2024005',
      bidders: 8,
      budget: '¥2,800万',
      reviewDeadline: '2024-02-18 17:00',
      inviteTime: '2024-02-12 14:30',
      status: '待开始'
    }
  ];

  const ongoingReviews = [
    {
      id: 1,
      projectName: '办公楼装修工程',
      projectCode: 'ZB2024002',
      bidders: 8,
      reviewed: 5,
      progress: 62,
      myScore: 85,
      avgScore: 82
    },
    {
      id: 2,
      projectName: '信息化系统建设项目',
      projectCode: 'ZB2024003',
      bidders: 15,
      reviewed: 10,
      progress: 66,
      myScore: 78,
      avgScore: 80
    }
  ];

  const reviewCriteria = [
    { name: '技术方案', weight: '30%', description: '技术方案的可行性和创新性' },
    { name: '报价合理性', weight: '25%', description: '投标价格的合理性和竞争力' },
    { name: '企业资质', weight: '20%', description: '企业资质和业绩情况' },
    { name: '项目经验', weight: '15%', description: '类似项目的实施经验' },
    { name: '服务方案', weight: '10%', description: '售后服务和保障方案' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                  <i className="ri-user-star-line text-xl text-white"></i>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">评审专家工作台</h1>
                  <p className="text-sm text-gray-500">王教授 - 建筑工程专家</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button className="px-4 py-2 text-gray-600 hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
              <button className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 whitespace-nowrap cursor-pointer">
                <i className="ri-file-list-line mr-2"></i>
                评审指南
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-sm">
              <div className="border-b border-gray-200 px-6">
                <div className="flex space-x-8">
                  {[
                    { id: 'pending', label: '待评审', icon: 'ri-time-line' },
                    { id: 'ongoing', label: '评审中', icon: 'ri-file-search-line' },
                    { id: 'completed', label: '已完成', icon: 'ri-checkbox-circle-line' }
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors ${
                        activeTab === tab.id
                          ? 'border-orange-600 text-orange-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      <i className={`${tab.icon} mr-2`}></i>
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="p-6">
                {activeTab === 'pending' && (
                  <div className="space-y-4">
                    {pendingReviews.map((review) => (
                      <div key={review.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{review.projectName}</h3>
                              <span className="px-3 py-1 bg-orange-100 text-orange-700 text-xs font-semibold rounded-full whitespace-nowrap">
                                {review.status}
                              </span>
                            </div>
                            <div className="flex items-center space-x-6 text-sm text-gray-600 mb-3">
                              <span><i className="ri-price-tag-3-line mr-1"></i>{review.projectCode}</span>
                              <span><i className="ri-money-cny-circle-line mr-1"></i>{review.budget}</span>
                              <span><i className="ri-team-line mr-1"></i>{review.bidders}家投标企业</span>
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
                          <div>
                            <div className="text-xs text-gray-500 mb-1">邀请时间</div>
                            <div className="text-sm font-semibold text-gray-900">{review.inviteTime}</div>
                          </div>
                          <div>
                            <div className="text-xs text-gray-500 mb-1">评审截止</div>
                            <div className="text-sm font-semibold text-orange-600">{review.reviewDeadline}</div>
                          </div>
                        </div>
                        <div className="flex items-center justify-end space-x-2">
                          <button className="px-4 py-2 text-orange-600 border border-orange-600 rounded-lg hover:bg-orange-50 whitespace-nowrap cursor-pointer">
                            查看详情
                          </button>
                          <button className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 whitespace-nowrap cursor-pointer">
                            开始评审
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'ongoing' && (
                  <div className="space-y-4">
                    {ongoingReviews.map((review) => (
                      <div key={review.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{review.projectName}</h3>
                              <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full whitespace-nowrap">
                                评审中
                              </span>
                            </div>
                            <div className="text-sm text-gray-600 mb-3">
                              <i className="ri-price-tag-3-line mr-1"></i>{review.projectCode}
                            </div>
                          </div>
                        </div>
                        <div className="mb-4">
                          <div className="flex items-center justify-between text-sm mb-2">
                            <span className="text-gray-600">评审进度: {review.reviewed}/{review.bidders}</span>
                            <span className="font-semibold text-gray-900">{review.progress}%</span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-blue-600 h-2 rounded-full transition-all" style={{ width: `${review.progress}%` }}></div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
                          <div>
                            <div className="text-xs text-gray-500 mb-1">我的评分</div>
                            <div className="text-2xl font-bold text-orange-600">{review.myScore}</div>
                          </div>
                          <div>
                            <div className="text-xs text-gray-500 mb-1">平均分</div>
                            <div className="text-2xl font-bold text-gray-900">{review.avgScore}</div>
                          </div>
                        </div>
                        <div className="flex items-center justify-end space-x-2">
                          <button className="px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 whitespace-nowrap cursor-pointer">
                            查看详情
                          </button>
                          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 whitespace-nowrap cursor-pointer">
                            继续评审
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'completed' && (
                  <div>
                    <div className="text-center py-12">
                      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-checkbox-circle-line text-4xl text-green-600"></i>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">已完成评审</h3>
                      <p className="text-gray-600 mb-4">查看所有已完成的评审项目</p>
                      <button className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 whitespace-nowrap cursor-pointer">
                        查看历史记录
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Expert Info */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">专家信息</h3>
              <div className="text-center mb-4">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-3xl text-white font-bold">王</span>
                </div>
                <div className="text-lg font-bold text-gray-900">王教授</div>
                <div className="text-sm text-gray-500">建筑工程专家</div>
              </div>
              <div className="space-y-3 pt-4 border-t border-gray-200">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">专家等级</span>
                  <span className="font-semibold text-orange-600">高级</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">评审次数</span>
                  <span className="font-semibold text-gray-900">36次</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">专家评分</span>
                  <div className="flex items-center">
                    <span className="font-semibold text-gray-900 mr-1">9.5</span>
                    <i className="ri-star-fill text-yellow-500"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Review Criteria */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">评审标准</h3>
              <div className="space-y-3">
                {reviewCriteria.map((criteria, index) => (
                  <div key={index} className="p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-semibold text-gray-900 text-sm">{criteria.name}</span>
                      <span className="text-orange-600 font-bold text-sm">{criteria.weight}</span>
                    </div>
                    <p className="text-xs text-gray-600">{criteria.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Guidelines */}
            <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl shadow-sm p-6 text-white">
              <h3 className="text-lg font-bold mb-4">评审须知</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start space-x-2">
                  <i className="ri-shield-check-line mt-0.5 flex-shrink-0"></i>
                  <span>保持公正客观的评审态度</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-shield-check-line mt-0.5 flex-shrink-0"></i>
                  <span>严格按照评审标准打分</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-shield-check-line mt-0.5 flex-shrink-0"></i>
                  <span>保守评审过程中的秘密</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-shield-check-line mt-0.5 flex-shrink-0"></i>
                  <span>及时完成评审任务</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
